<template>
  <span>
    <a class="open_btn" @click="showPreviewInfo()">预习分析</a>
    <a-modal :visible="previewVisible" :loading="loading" :destroyOnClose="true" :width="1200" title="预习任务分析"
      @ok="previewVisible = false;" @cancel="previewVisible = false;">
      <h2 style="text-align: center">{{ previewTitle }}</h2>
      <h3 style="text-align: center">任务概况</h3>
      <a-table :dataSource="squadInfo" :loading="loading" :rowKey="item => item.mission_id" :pagination="false" bordered>
        <a-table-column title="开始时间">
          <template slot-scope="item">
            {{ moment(item.start_time * 1000).format('lll') }}
          </template>
        </a-table-column>
        <a-table-column title="结束时间">
          <template slot-scope="item">
            {{ moment(item.end_time * 1000).format('lll') }}
          </template>
        </a-table-column>
        <a-table-column key="squad_student_cnt" title="班级人数" data-index="squad_student_cnt" />
        <a-table-column key="squad_student_arrive" title="应测人数" data-index="squad_student_arrive" />
        <a-table-column key="squad_student_actual" title="实测人数" data-index="squad_student_actual" />
        <a-table-column key="student_rate" title="参测率">
          <template slot-scope="item">
            {{ (item.squad_student_actual / item.squad_student_cnt * 100).toFixed(2) }}%
          </template>
        </a-table-column>
        <a-table-column key="problems_cnt" title="答题总数" data-index="problems_cnt" />
        <a-table-column key="problems_isright" title="正确总数" data-index="problems_isright" />
        <a-table-column key="right_rate" title="正确率">
          <template slot-scope="item">
            {{ (item.problems_isright / item.problems_cnt * 100).toFixed(2) }}%
          </template>
        </a-table-column>
        <a-table-column key="avg_student_time" title="平均观看时长" data-index="avg_student_time" />
      </a-table>
      <h3 style="text-align: center;margin-top: 10px;">单个预习视频概况</h3>
      <a-table :dataSource="previewProblemList" :loading="loading" :rowKey="item => item.problems_id" :pagination="false"
        bordered>
        <a-table-column key="title" title="题目名字">
          <template slot-scope="item">
            <span v-html="item.title" />
          </template>
        </a-table-column>
        <a-table-column key="problem_student_arrive" title="应观看人数" data-index="problem_student_arrive" />
        <a-table-column key="problem_student_actual" title="实际观看人数" data-index="problem_student_actual" />
        <a-table-column key="previewvideo_time" title="视频时长">
          <template slot-scope="item">
            {{ Math.floor(item.previewvideo_time / 60) }}分{{ Math.floor((item.previewvideo_time) % 60) }}秒
          </template>
        </a-table-column>
        <a-table-column key="avg_video_play_time" title="平均观看时长">
          <template slot-scope="item">
            {{ Math.floor(item.avg_video_play_time / 1000 / 60) }}分{{ Math.floor((item.avg_video_play_time / 1000) % 60)
            }}秒
          </template>
        </a-table-column>
        <a-table-column key="student_player_rate" title="观看率">
          <template slot-scope="item">
            {{ item.problem_student_arrive > 0 ? (item.problem_student_actual / item.problem_student_arrive *
              100).toFixed(2) : 0 }}%
          </template>
        </a-table-column>
      </a-table>
      <h3 style="text-align: center;margin-top: 10px;">检测题答题概况</h3>
      <a-table :dataSource="studentTestingList" :loading="loading" :rowKey="item => item.id" :pagination="false" bordered>
        <a-table-column :width="400" key="title" title="题目名字">
          <template slot-scope="item">
            <span v-html="item.title" />
          </template>
        </a-table-column>
        <a-table-column key="cnt" title="答题总数" data-index="cnt" />
        <a-table-column key="right_cnt" title="正确数" data-index="right_cnt" />
        <a-table-column key="error_cnt" title="错误数">
          <template slot-scope="item">
            {{ item.cnt - item.right_cnt }}
          </template>
        </a-table-column>
        <a-table-column key="student_player_rate" title="正确率">
          <template slot-scope="item">
            {{ item.cnt > 0 ? (item.right_cnt / item.cnt * 100).toFixed(2) : 0 }}%
          </template>
        </a-table-column>
      </a-table>
      <h3 style="text-align: center;margin-top: 10px;">学生答题情况</h3>
      <a-table :dataSource="studentAllInfo" :columns="columnData" :loading="loading" :rowKey="item => item.user_id"
        :pagination="false" :render="rrren" bordered>
      </a-table>
      <record title="我的班级" :class_id="itemdata.squad_id" :chapter_name="previewTitle" />
    </a-modal>
    <a-modal :visible="imageShow" :footer="null" @cancel="imageShow=false;imageDeg=0">
      <div class="header">
        <a-icon class="" type="redo" style="font-size: 25px;" title="旋转" @click="imageTranslate" />
      </div>
      <div class="body">
        <img class="transform-image" style="width: 100%;user-select: none;" :src="previewImage" />
      </div>
    </a-modal>
    <a-modal :visible="videoShow" :footer="null" @cancel="videoShow=false;imageDeg=0">
      
      <div class="body" style="height: 90%;">
        <video class="video" style="width: 100%; display: block;" v-if="videoShow" :src="previewvideo" controls />
       
      </div>
    </a-modal>
    <a-modal :visible="audioShow" :footer="null" @cancel="audioShow=false;imageDeg=0">
      
      <div class="body">
        <audio style="width: 100%; display: block; " :src="previewaudio"
        v-if="audioShow"   controls preload="metadata" />
      </div>
    </a-modal>
  </span>
</template>
<script>
import moment from "moment";
import Record from '../../components/record.vue';

export default {
  components: { Record },
  props: {
    itemdata: {}
  },
  data() {
    return {
      pageinfo: {
        total: 1,
        current: 1,
        pageSize: 10
      },
      loading: false,
      previewVisible: false,
      squad_id: undefined,
      mission_id: undefined,
      squadInfo: [],
      previewTitle: '预习任务',
      previewProblemList: [],
      studentTestingList: [],
      columnData: [],
      studentAllInfo: [],
      idx: '',
      xxinfo: [],
      imageShow:false,
      videoShow:false,
      audioShow:false,
      previewImage:'',
      previewvideo:'',
      previewaudio:'',
      imageDeg:0
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    imageTranslate(){
      let img = document.querySelector('.transform-image');
      this.imageDeg += 90;
      img.style.transform = 'rotate('+this.imageDeg+'deg)';
    },
    rrren() {
      console.info('aaaaaaaaa');
    },
    rendertdTimeBackground(a, b) {
      console.info('a', a);
      console.info('b', b);
    },
    renderTimeBackground(answer, user_answer) {
      console.info("asasjhdajshdkaj");
      if (answer == user_answer) {
        return {
          style: {
            'background-color': 'rgb(0,0,0)',
          }
        }
      } else {
        return {
          style: {
            'background-color': 'rgb(255,0,0)'
          }
        }
      }
    },
    showPreviewInfo() {
      this.previewVisible = true;
      this.getPreviewInfo();
    },
    tdReplaceImage() {
      let tds = document.querySelectorAll('.answer-image');
      for (let i = 0; i < tds.length; i++) {
        let value = tds[i].innerHTML;
        console.log(value);
        if(value.indexOf('jpg') != -1||value.indexOf('png') != -1){
          let btn = document.createElement('button');
          btn.className = 'look-image';
          btn.innerHTML = '查看图片';
          btn.style = 'height:28px;line-height:1.3;white-space:nowrap;cursor:pointer;padding:4px 15px;border-radius:20px;font-size:12px;background-color:#b3acf2;color:#fff;border:none;outline:none;';
          btn.addEventListener('click',()=>{
            this.previewImage = value;
            this.imageShow = true;
          })
          tds[i].innerHTML = '';
          tds[i].appendChild(btn);
        }
        if(value.indexOf('mp4') != -1){
          let btn = document.createElement('button');
          btn.className = 'look-image';
          btn.innerHTML = '播放视频';
          btn.style = 'height:28px;line-height:1.3;white-space:nowrap;cursor:pointer;padding:4px 15px;border-radius:20px;font-size:12px;background-color:#b3acf2;color:#fff;border:none;outline:none;';
          btn.addEventListener('click',()=>{
            this.previewvideo = value;
           
            this.videoShow = true;
          })
          tds[i].innerHTML = '';
          tds[i].appendChild(btn);
        }
        if(value.indexOf('mp3') != -1){
          let btn = document.createElement('button');
          btn.className = 'look-image';
          btn.innerHTML = '播放音频';
          btn.style = 'height:28px;line-height:1.3;white-space:nowrap;cursor:pointer;padding:4px 15px;border-radius:20px;font-size:12px;background-color:#b3acf2;color:#fff;border:none;outline:none;';
          btn.addEventListener('click',()=>{
            this.previewaudio = value;
           
            this.audioShow = true;
          })
          tds[i].innerHTML = '';
          tds[i].appendChild(btn);
        }
      }
    },
    getPreviewInfo() {
      this.loading = true;
      this.$axios
        .post("/api/SquadMission/getSquadPreviewAllInfo", {
          data: { squad_id: this.itemdata.squad_id, mission_id: this.itemdata.mission_id }
        })
        .then(res => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.xxinfo = res;
            this.squadInfo = [res.data.squadInfo];
            this.previewTitle = res.data.squadInfo.gradename + " - " + res.data.squadInfo.missionname;
            this.previewProblemList = res.data.previewProblemList;
            this.studentTestingList = res.data.studentTestingList;
            for (let i = 0; i < res.data.columnData.length; i++) {
              let str = res.data.columnData[i]['key'].substr(0, 6)
              if (str == 'answer') {
                let idx = res.data.columnData[i]['key'].replace('answer', "");
                res.data.columnData[i]['customCell'] = function (item) {
                  if (item['correct' + idx] == 1 && item['isright' + idx] == 0) {
                    return {
                      style: {
                        'background-color': 'rgb(255,150,150)'
                      },
                      class: 'answer-image',
                    }
                  } else if (item['correct' + idx] == 1 && item['isright' + idx] == 1) {
                    return {
                      style: {
                        'background-color': 'rgb(150,255,150)'
                      },
                      class: 'answer-image',
                    }
                  }else{
                    return {
                      class: 'answer-image',
                    }
                  }
                }

              }
            }
            this.columnData = res.data.columnData;
            this.studentAllInfo = res.data.allStudentList;
            this.$nextTick(() => {
              this.tdReplaceImage()
            })
          }
        })
        .catch(err => {
          console.error(err);
        });
    }, moment
  }
}
  ;
</script>


<style lang="less" scoped>
.open_btn {}

.main {
  margin-top: 1.5rem;
}

.row {
  margin-top: 1rem;
}

.title {
  font-weight: 700;
  font-family: 微软雅黑, tahoma;
}

.page {
  display: flex;
  justify-content: space-between;
}
</style>
